import { tagTypes, hiddenTagTypes } from './configParams';
import { getLanguage } from 'wdz-common-components/src/common/js/ovoSystem';

/**
 * 过滤不需要的标签
 */
export const filterTags = function (modules) {
  // console.log('modules');
  // console.log(modules)
  if (modules) {
    let keys = Object.keys(tagTypes);
    // console.log('tagTypes');
    // console.log(tagTypes);
    // console.log('keys');
    // console.log(keys);
    const lang = getLanguage();
    let hiddenKeys = hiddenTagTypes[lang] || [];
    return modules.filter(item => {
      let tagType;
      if (
        item.tagType !== tagTypes.userDefinedType.value &&
        item.tagType !== tagTypes.myModules.value &&
        item.tagType !== tagTypes.messages.value &&
        (tagType = keys.find(key => {
          return tagTypes[key].value === item.tagType;
        })) &&
        !hiddenKeys.includes(item.tagType)
      ) {
        item.tagCompontentName = tagTypes[tagType].componentName; //这里主要为了给组件加上一个name,动态组件的关键
        // console.log(item);
        return true;
      }
      return false;
    });
  }
  return [];
};
/**
 * 过滤出可被订阅的菜单
 * @param menuList 所有我有权限的模块菜单
 * @param subscribes 我已经订阅的模块菜单
 */
export const filterConfigMenu = function (menuList, subscribes) {
  let menus = [];
  menuList.reduce((curMenus, menu) => {
    let childs = [];
    menu.children.map(child => {
      child.status =
        subscribes.length > 0
          ? !!subscribes.find(item => item.id === child.id)
          : false;
      if (child.isSubscribe) {
        childs.push(child);
      }
    });
    menu.children = childs;
    if (childs.length > 0) {
      curMenus.push(menu);
    }
    return curMenus;
  }, menus);
  return menus;
};
/**
 * 获取我已经开启订阅的模块
 */
export const getSubcribeMenus = function (menuList) {
  let menus = [];
  menuList.map(menu => {
    menu.children.map(child => {
      if (child.isSubscribe && child.status) {
        menus.push(child);
      }
    });
  });
  return menus;
};

/**
 * 过滤出默认的常用菜单，isDefaultSubscribe:true
 */
export const filterDefaultMenu = function (menuList, subscribes) {
  let menus = [];
  let hasSubscribe = !!subscribes.length; //是否已经订阅
  //取所有可订阅的模块菜单
  menuList.map(menu => {
    menu.children.map(child => {
      if (!hasSubscribe && child.isSubscribe && child.isDefaultSubscribe) {
        menus.push(child);
      } else if (hasSubscribe && child.isSubscribe) {
        menus.push(child);
      }
    });
  });
  //如果没有订阅，则取isDefaultSubscribe=true的
  if (!hasSubscribe) {
    return menus;
  } else {
    let resultMenus = [];
    //后台返回的和自己有权限的菜单取交集
    subscribes.forEach(menu => {
      let localMenu = menus.find(item => item.id == menu.moduleCode);
      if (localMenu) {
        resultMenus.push(localMenu);
      }
    });
    return resultMenus;
  }
};
